export default {
  routes: [
    {
      name: 'productioncalendars',
      path: '/directory/productioncalendar',
      component: () => import('./views/TheProductionCalendarPages.vue'),

    },

    {
      name: 'productioncalendar',
      path: '/directory/productioncalendar/:uuid',
      component: () => import('./views/TheProductionCalendarPage.vue'),
    },
  ]
}
